import React, { useEffect, useState } from "react";

import { Pie } from "react-chartjs-2";
import getChartColorsArray from "./ChartsDynamicColor";

import { useNavigate } from "react-router-dom";

const PieChart = ({ chartData, dataColors }) => {
  const pieChartColors = getChartColorsArray(dataColors);
  const navigate = useNavigate();

  const data = {
    labels: chartData.map((item) => item.itemName),
    datasets: [
      {
        data: chartData.map((item) => item.percentage),
        backgroundColor: pieChartColors,
        hoverBackgroundColor: pieChartColors,
        hoverBorderColor: "#fff",
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "right",
        labels: { font: { family: "Poppins" } },
      },
    },
    onClick: (evt, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const clickedItem = chartData[index];
        if (clickedItem.itemName === "Others") {
          navigate("/percent-wise-item/all/");
        }
      }
    },
  };

  return <Pie className="chartjs-chart" data={data} options={options} />;
};

export default PieChart;
